import IntegrationIndicator from './IntegrationIndicator';

export default IntegrationIndicator;
